import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { SendPhone2FATemplate } from '../../templates/SendPhone2FATemplate'
import PropTypes from 'prop-types'
import { ArrowLeft } from '@olxbr/olx-icons/dist/System'
import { CountdownContext } from '../../../util/providers/CountdownProvider'
import { breakpoints } from '../../../util/medias'
import { sendCode2FA } from '../../../api/phoneValidationApiCall'
import { getAttemptCheck2FA } from '../../../api/attemptCheckAPI'
import { SEND_MODES } from '../../templates/CheckPinCodeTemplate'
import { TipsBox } from '../../organisms/TipsBox'

const PincodeWrapper = styled.div`
  max-width: 600px;
  flex: 1;
  flex-direction: column;
  margin: auto;
  @media screen and (min-width: ${breakpoints['mobile'] + 1}px) and (max-width: ${breakpoints[
      'tablet'
    ]}px) {
    width: 80vw;
  }
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin: 0 auto;
    justify-content: center;
    margin-left: var(--spacing-2);
    margin-right: var(--spacing-2);
  }
`

const StyledTitle = styled.span.attrs({ className: 'typo-title-large' })`
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin-bottom: var(--spacing-2);
  }
`

const Title = styled.span.attrs({ className: 'typo-body-large' })`
  display: block;
  font-size: var(--font-size-3);
  margin-bottom: var(--spacing-4);
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    font-size: var(--font-size-2-25);
    margin-bottom: var(--spacing-2);
  }
`

const StyledArrow = styled(ArrowLeft)`
  color: var(--color-neutral-130);
`
const ArrowContainer = styled.div`
  cursor: pointer;
  margin-bottom: var(--spacing-4);

  ${({ modalMode }) => modalMode && `margin-bottom: var(--spacing-2);`}
`
const smsType = SEND_MODES.PHONE

const issuer = 'AccountsValhallaGreyLogin'

export const SendPhone2FAPage = ({
  onSuccess,
  onChooseAnotherMethodClick,
  phone,
  token,
  abTests,
  redirectToVerifyYourAccess,
  onGetPublicAccountId,
  modalMode,
  onChooseSendMode,
}) => {
  const { lockTime, checkAttemptLockTime } = useContext(CountdownContext)

  const onSendPinCode = type => {
    if (onChooseSendMode) onChooseSendMode(type)
    return sendCode2FA(type, issuer, token)
  }

  const onSendSMS = () => {
    if (onChooseSendMode) onChooseSendMode(smsType)
    return sendCode2FA(smsType, issuer, token)
  }

  const checkAttempt = () => getAttemptCheck2FA(token)

  useEffect(() => {
    checkAttemptLockTime(checkAttempt)
  }, [])

  return (
    <PincodeWrapper>
      <ArrowContainer modalMode={modalMode} onClick={onChooseAnotherMethodClick}>
        <StyledArrow />
      </ArrowContainer>

      {!modalMode && (
        <Title>
          Vamos deixar sua <span className="font-semibold">conta mais segura</span>
        </Title>
      )}

      {modalMode && <span className="typo-title-medium mb-2">Verificação de Telefone</span>}

      {modalMode && (
        <span className="typo-title-medium mb-2">
          Vamos deixar sua{' '}
          <span className="typo-title-medium font-semibold inline">conta mais segura</span>
        </span>
      )}

      <SendPhone2FATemplate
        onSuccess={onSuccess}
        onChooseAnotherMethodClick={onChooseAnotherMethodClick}
        sendPinCode={onSendPinCode}
        sendSMS={onSendSMS}
        lockTime={lockTime}
        phone={phone}
        token={token}
        abTests={abTests}
        redirectToVerifyYourAccess={redirectToVerifyYourAccess}
        onGetPublicAccountId={onGetPublicAccountId}
        modalMode={modalMode}
      />
      <TipsBox />
    </PincodeWrapper>
  )
}

SendPhone2FAPage.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onChooseAnotherMethodClick: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  abTests: PropTypes.string,
  token: PropTypes.string,
  redirectToVerifyYourAccess: PropTypes.func,
  onGetPublicAccountId: PropTypes.func,
  modalMode: PropTypes.bool,
  onChooseSendMode: PropTypes.func,
}
